import { render } from "./AllVideoModal.vue?vue&type=template&id=4f8d677a&scoped=true"
import script from "./AllVideoModal.vue?vue&type=script&lang=js"
export * from "./AllVideoModal.vue?vue&type=script&lang=js"

import "./AllVideoModal.vue?vue&type=style&index=0&id=4f8d677a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8d677a"]])

export default __exports__